import React, { useEffect, useState } from 'react';
import { Text, Eyebrow, Heading, Types, Image, Icon, Button } from '@marriott/mi-ui-library';
import { CardStaticProps } from './CardStatic.types';
import { useGetBreakpoint } from '../../../../src/modules/utils/helpers';
import { StyledCardStatic } from './CardStatic.styles';
import { StaticAriticleDescriptionLimit } from '../../../modules/utils/constants/constants';
import { TRACKING_CONSTANT } from '../../../modules/utils/constants';
import clsx from 'clsx';

export const CardStatic: React.FC<CardStaticProps> = ({
  eyebrow,
  imgAltText,
  dynamicMedia,
  title,
  iconPathMinuteRead,
  minuteRead,
  description,
  ctaLinkText,
  openInNewTab,
  ctaLink,
}) => {
  const [breakpoint, setBreakpoint] = useState(useGetBreakpoint());
  const { CITY_ARTICLE_COMPONENT, CITY_ARTICLE_CARD_BUTTON, EXTERNAL_LINK } = TRACKING_CONSTANT;

  // Reset breakpoint on window resize.
  useEffect(() => {
    const handleResize = () => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      setBreakpoint(useGetBreakpoint());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const updatedDescription =
    description?.length >= StaticAriticleDescriptionLimit
      ? description?.slice(0, StaticAriticleDescriptionLimit) + ' [...]'
      : description;
  return (
    <StyledCardStatic className="container ">
      <div className="card-static-container py-xl-5 d-flex flex-column flex-md-row flex-lg-row flex-xl-row ">
        <div className={clsx('pb-3 pt-5 pt-lg-4 pt-xl-4 px-0 px-md-4 px-lg-4 px-xl-4 d-md-none card-static-rtl')}>
          {eyebrow && <Eyebrow text={eyebrow} />}
        </div>
        <div className="col-12 col-sm-12 col-md-5 static-article-left-container d-flex justify-content-start justify-content-md-start flex-wrap align-items-center">
          <Image
            title="Article-image"
            defaultImageURL={dynamicMedia?.assetPath}
            altText={imgAltText}
            customClass=""
            renditions={dynamicMedia?.renditions}
            dynamic={dynamicMedia?.dynamic}
          />
        </div>
        <div className="static-article-right-container col-md-7 px-0 py-4 px-sm-0 px-md-5 py-md-4 p-lg-5 p-xl-5">
          <div className={clsx('pb-1 d-none d-md-block card-static-rtl')}>{eyebrow && <Eyebrow text={eyebrow} />}</div>
          <Heading
            variation={Types.headingType.subtitle}
            titleText={title}
            element={Types.tags.h2}
            customClass={clsx('pt-1 card-static-rtl')}
            fontSize={
              breakpoint === 'desktop'
                ? Types.size.extraLarge
                : breakpoint === 'tablet'
                ? Types.size.large
                : Types.size.medium
            }
          ></Heading>

          <div className={clsx('d-flex flex-row align-items-center card-static-rtl')}>
            <Icon iconClass={iconPathMinuteRead} />
            <Text
              customClass={clsx('t-font-alt-s p-1 pb-1 p-md-0 card-static-minutes-read')}
              fontSize={Types.size.small}
              element={Types.tags.paragraph}
              copyText={minuteRead}
            />
          </div>
          <Text
            customClass={clsx('pt-2 pt-md-3 card-static-rtl')}
            fontSize={Types.size.small}
            element={Types.tags.paragraph}
            copyText={updatedDescription}
          />

          <div className={'card-static-rtl'}>
            <Button
              isLink={openInNewTab}
              href={ctaLink}
              target={openInNewTab ? '_blank' : '_self'}
              className={clsx('m-link-tertiary-button pt-3 pb-2 pt-md-5 card-static-cta-rtl')}
              children={ctaLinkText}
              custom_click_track_value={`${CITY_ARTICLE_COMPONENT}|${CITY_ARTICLE_CARD_BUTTON}|${EXTERNAL_LINK}`}
            />
          </div>
        </div>
      </div>
    </StyledCardStatic>
  );
};
